import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { MetadataItem } from './metadata-item.type';
import { SearchHierarchyElementDto } from './search-hierarchy-element-dto.type';
import { SearchStatusDto } from './search-status-dto.type';

const SearchResultItemDto = t.type(
  {
    entityNumber: nullable(t.string),
    entityType: nullable(t.string),
    id: nullable(t.string),
    name: nullable(t.string),
    hierarchy: nullable(t.array(SearchHierarchyElementDto)),
    highlights: nullable(t.record(t.string, t.string)),
    status: nullable(SearchStatusDto),
    metadata: nullable(t.record(t.string, nullable(MetadataItem))),
    score: nullable(t.number),
  },
  'SearchResultItemDto ',
);

type SearchResultItemDto = t.TypeOf<typeof SearchResultItemDto>;
export { SearchResultItemDto };
